<template>
  <v-container class="d-flex justify-center pa-0">
    <v-card
      style="
        width: 600px;
        border: 1px solid lightgray;
        padding-left: 20px;
        padding-right: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
      "
      :disabled="page_disabled"
    >
      <v-row
        justify="center"
        align="center"
        style="padding: 10px; height: auto"
      >
        <!-- <img src="@/assets/undefined.png" alt="BAS Logo" style="height: auto; max-height: 100px; max-width: 100%; margin-top: 10px" /> 
         -->
        <header class="header">
          <img class="header-logo center-logo" :src="basLogoSrc" alt="BAS" />
          <img class="header-logo center-logo" :src="ccsLogoSrc" alt="CCS" />
        </header>
      </v-row>

      <v-row justify="center" align="center">
        <span
          style="
            font-weight: bold;
            color: black;
            display: block;
            font-size: 20px;
            margin-bottom: 10px;
            text-align: center;
          "
          >Make a Payment</span
        >
        <span
          style="
            font-weight: bold;
            color: black;
            display: block;
            font-size: 17px;
            margin-bottom: 10px;
            text-align: center;
          "
        >
          The 'Make a Payment' application is currently available for certain
          billing accounts. We will notify users when it becomes available for
          additional billing types.
        </span>
        <span
          style="
            color: black;
            display: block;
            font-size: 17px;
            margin-bottom: 20px;
            text-align: center;
          "
        >
          To make a payment without logging into MyEnroll360, we need you to
          follow the steps below where you'll identify yourself!
        </span>
      </v-row>

      <v-row style="" align="center" justify="center">
        <span
          style="
            font-weight: bold;
            display: block;
            font-size: 17px;
            margin-bottom: 20px;
            text-align: left;
          "
          >Step 1: Identify Yourself</span
        >
      </v-row>

      <!-- <v-row align="center" style="gap: 10px; margin-left: 50px">
        <span style="margin-bottom: 25px">
          Record Locator Code
          <span style="color: red">*</span>
        </span>
        <div style="width: 130px; margin-left: 30px">
          <v-text-field
            variant="outlined"
            density="compact"
            v-model="recordLocator"
            :rules="[requiredRule]"
            maxlength="6"
            style="color: black; border-color: black"
          ></v-text-field>
        </div>
       
      </v-row> -->

      <v-row align="center" class="form-row">
        <v-col cols="12" sm="6" md="5" class="d-flex align-center">
          <span style="font-weight: 600; display: block">
            Record Locator Code <span style="color: red">*</span>
          </span>
        </v-col>

        <v-col cols="12" sm="4" md="3">
          <v-text-field
            variant="outlined"
            density="compact"
            v-model="recordLocator"
            :rules="[requiredRule]"
            maxlength="8"
            class="black-input"
            hide-details
          />
        </v-col>
      </v-row>
      <!-- First Initial -->
      <v-row align="center" class="form-row">
        <v-col cols="12" sm="6" md="5" class="d-flex align-center">
          <span style="font-weight: 600; display: block">
            First Name 1st Initial <span style="color: red">*</span>
          </span>
        </v-col>

        <v-col cols="12" sm="2" md="2">
          <v-text-field
            variant="outlined"
            density="compact"
            v-model="firstInitial"
            :rules="[requiredRule]"
            maxlength="3"
            class="black-input initial-input"
            hide-details
          />
        </v-col>
      </v-row>

      <!-- Last Initial -->
      <v-row align="center" class="form-row">
        <v-col cols="12" sm="6" md="5" class="d-flex align-center">
          <span style="font-weight: 600; display: block">
            Last Name 1st Initial <span style="color: red">*</span>
          </span>
        </v-col>

        <v-col cols="12" sm="2" md="2">
          <v-text-field
            variant="outlined"
            density="compact"
            v-model="lastInitial"
            :rules="[requiredRule]"
            maxlength="3"
            class="black-input initial-input"
            hide-details
          />
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <RecaptchaV3
          ref="recaptcha"
          @verified="onCaptchaVerified"
          v-if="showrecaptcha"
        />
      </v-row>
      <v-row align="center" justify="center" style="margin-top: 25px">
        <v-btn
          color="primary"
          @click="onSubmit"
          :loading="save_loading"
          style="
            height: 35px;
            width: auto;
            border-radius: 10px;
            color: white;
            margin-bottom: 20px;
          "
        >
          Validate Your Account
        </v-btn>
      </v-row>

      <div v-if="nextStep === true">
        <v-row align="center" justify="center" v-if="loading">
          <v-col cols="12" md="12" justify-center>
            <v-overlay class="align-center justify-center">
              <v-progress-circular
                color="primary"
                indeterminate
                size="65"
              ></v-progress-circular>
            </v-overlay>
          </v-col>
        </v-row>
        <hr style="border: 1px solid lightgray; margin-top: 35px" />
        <v-row style="margin-top: 20px" align="center" justify="center">
          <span
            style="
              font-weight: bold;
              display: block;
              font-size: 17px;
              margin-bottom: 20px;
              text-align: left;
            "
            >Step 2: Confirm Your Account</span
          >
        </v-row>

        <v-row>
          <span class="ml-10 mr-15 mb-3">First Name :</span>
          <span>
            <strong>{{ ee_data.FIRST_NAME }}</strong>
          </span>
        </v-row>
        <v-row>
          <span class="ml-10 mr-15 mb-3">Last Name :</span>
          <span>
            <strong>{{ ee_data.LAST_NAME }}</strong>
          </span>
        </v-row>
        <v-row>
          <span class="ml-10 mr-7 mb-3">Home Zip Code :</span>
          <span>
            <strong>{{ ee_data.ZIP_CODE }}</strong>
          </span>
        </v-row>

        <v-row
          align="center"
          justify="center"
          style="margin-bottom: 30px; margin-top: 30px"
        >
          <v-btn
            color="success"
            @click="onContinue"
            style="
              height: auto;
              width: auto;
              border-radius: 10px;
              padding: 10px 15px;
              white-space: normal;
              line-height: 1.2;
              text-align: center;
            "
          >
            Confirm & Continue
            <br />
            to Payment Page
          </v-btn>
        </v-row>

        <!-- ------------------- -->
      </div>

      <!-- 8/14/2025 PRG-1944 -->
      <v-dialog v-model="showprivacy" max-width="550px">
        <div>
          <v-card align="center" justify="center" class="png-card">
            <v-row
              justify="center"
              align="center"
              style="padding: 10px; height: auto"
            >
              <header class="header">
                <img
                  class="header-logo center-logo"
                  :src="basLogoSrc"
                  alt="BAS"
                />
                <img
                  class="header-logo center-logo"
                  :src="ccsLogoSrc"
                  alt="CCS"
                />
              </header>
            </v-row>

            <h1 id="png-title" class="png-title my-5">Privacy Notice</h1>
            <v-card elevation="0" class="png-card1 ma-5">
              <p class="pa-3 my-2">
                You are accessing a third party information data system. By
                continuing to use this system, you understand and agree to abide
                by the MyEnroll360 Terms of Service and Privacy Policy which may
                be accessed under &ldquo;About&rdquo; on the MyEnroll.com home
                page. You understand that your use of the system may be
                monitored, recorded or audited, and that we use cookies and
                other tracking technologies to assist with system navigation. By
                continuing to use this system, you agree to these terms.
                Unauthorized use of this site is strictly prohibited.
              </p></v-card
            >

            <div class="png-button-row my-5 mb-10">
              <v-btn
                type="button"
                color="primary"
                class="png-btn accept py-2"
                @click="onAccept"
                ref="acceptBtn"
              >
                ACCEPT &amp; CONTINUE
              </v-btn>
              <v-btn
                type="button"
                class="png-btn decline py-2"
                @click="onDecline"
              >
                NO
              </v-btn>
            </div>
          </v-card>
        </div>
      </v-dialog>

      <v-dialog v-model="errorDialog_1" max-width="550px">
        <v-card align="center" justify="center">
          <v-card-title style="color: red" class="d-flex justify-center"
            >Your Record Locator</v-card-title
          >
          <v-card-text>
            <p class="text-title-1">
              We're unable to find a match for your Record Locator Number, First
              name 1st Inital and Last Name 1st Initial combination.
            </p>
            <p class="text-title-1">
              Click the <strong>CLOSE</strong> button below, then you may train
              again.
            </p>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn
              variant="elevated"
              color="primary"
              @click="errorDialog_1 = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showvalidationdialog" max-width="550px">
        <v-card align="center" justify="center">
          <v-card-title style="color: red" class="d-flex justify-center"
            >Enter all the required fields</v-card-title
          >

          <v-card-actions class="d-flex justify-center">
            <v-btn
              variant="elevated"
              color="primary"
              @click="showvalidationdialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="errorDialog_2" max-width="550px">
        <v-card align="center" justify="center">
          <v-card-title style="color: red" class="d-flex justify-center"
            >Too Many failed Attempts!</v-card-title
          >
          <v-card-text>
            <p class="text-weight-bold">
              We're sorry , but you have made too many failed attempts. For
              security purposes,this application has been disabled.You many
              start over at
              <a :href="$store.state.myenroll_url" target="_blank">{{
                $store.state.myenroll_url
              }}</a>
            </p>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn
              variant="elevated"
              color="primary"
              @click="failedAttempts_redirect = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Email Dialog  Lakshmi - 6/26/2025-->
      <v-dialog
        v-model="email_error_dialog"
        height="55%"
        width="600px"
        persistent
        scrollable
      >
        <v-card>
          <v-card-title
            class="red--text my-2 py-2 font-weight-bold"
            style="font-size: 14.5px"
            >ERROR - Email Exists!</v-card-title
          >
          <v-card-text class="">
            <div class="black--text">
              <p class="py-1 my-0">
                The email address you entered already exists in the system.
              </p>

              <p class="py-1 my-0">
                To re-enter your email,
                <b>click</b>
                the Re-Enter button below.
              </p>
            </div>
          </v-card-text>
          <v-card-actions class="d-flex align-center justify-center my-5">
            <v-spacer></v-spacer>
            <v-btn @click="reenter()" variant="elevated" color="primary"
              >Re-Enter</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="emaildialog" max-width="550px">
        <v-card align="center" justify="center">
          <v-card-title style="color: blue" class="d-flex justify-center"
            >Enter your Email</v-card-title
          >
          <v-card-text>
            <v-row style="margin-bottom: 20px">
              <span
                >We currently do not have an email address on file to send a
                payment transaction confirmation. If you would like to receive a
                confirmation email, please enter your email address and click
                <strong>Submit</strong>. If not, simply click
                <strong>Skip</strong> to proceed.</span
              >
            </v-row>
            <v-row justify="center" align="center" dense>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Email Address"
                  variant="outlined"
                  :rules="emailRules"
                  v-model="emailEntry"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" dense>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Confirm Email Address"
                  variant="outlined"
                  :rules="emailRules"
                  v-model="confirmEmail"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn variant="elevated" color="primary" @click="saveemail()"
              >SUBMIT</v-btn
            >
            <v-btn variant="elevated" color="info" @click="skip()">SKIP</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="mfadialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card class="pa-0" height="100%">
          <iframe
            :src="mfa_url"
            width="100%"
            height="100%"
            style="border: none"
            allowfullscreen
          ></iframe>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import RecaptchaV3 from "./VerifyRecaptcha.vue";
import axios from "axios";
import basLogoImg from "@/assets/BAS_Logo.png";
import ccsLogoImg from "@/assets/CCS_Logo.png";
import { AddSessionInfo } from "@/utils/common.js";
export default {
  components: {
    RecaptchaV3,
  },

  mounted() {
    //this.initializeData();
    if (location.href.toLowerCase().indexOf("localhost") == -1) {
      //this.checkauthenticate();
    } else {
      this.initializeData();
      //this.intialloadfn();
    }
  },
  created() {
    if (location.href.toLowerCase().indexOf("localhost") == -1) {
      this.recaptchaSiteKey = this.sitekey_local;
    } else {
      this.recaptchaSiteKey = this.sitekey;
    }
  },
  computed: {
    methodUrl() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "https://www.bas1.myenroll.com";
      } else if (href.indexOf("temp.bastest") > -1) {
        return "https://www.temp.bastest.com";
      } else if (href.indexOf("localhost") > -1) {
        return "http://localhost/web_projects";
      } else {
        return "";
      }
    },
    emailRules() {
      var self = this;
      return [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        (v) =>
          (v && v.length <= 100) || "Must be at less than 100 characters long.",
        self.emailEntry == self.confirmEmail || "Emails must match",
      ];
    },
  },

  data() {
    return {
      showrecaptcha: true, //localhost make it false
      mfadialog: false,
      mfa_url: "",
      recordLocator: "",
      requiredRule: (value) => !!value || "*",
      firstInitial: "",
      lastInitial: "",
      nextStep: false,
      ee_data: [],
      errorDialog_1: false,
      errorDialog_2: false,
      err_counter: 0,
      page_disabled: false,
      loading: false,
      save_loading: false,
      showvalidationdialog: false,
      emailEntry: "",
      confirmEmail: "",
      emaildialog: false,
      email_error_dialog: false,
      basLogoSrc: basLogoImg,
      ccsLogoSrc: ccsLogoImg,
      showprivacy: false,
    };
  },

  methods: {
    async onCaptchaVerified({ result }) {
      // console.log("recap result" + result);
      try {
        if (result == "T") {
          this.verifyEELogin();
        }
      } catch (error) {
        console.error("Error during captcha verification:", error);
        this.save_loading = false;
      }
      this.showvalidationdialog = false;
    },

    onGet() {
      console.log("Get clicked");
    },

    async initializeData() {
      // try {
      // } catch (error) {
      //   console.log("Error initializing data:", error);
      // }
    },
    async myenroll_url_details() {
      var self = this;
      await axios
        .post(`${this.methodUrl}/make_payment/Webservice.asmx/myenroll_url`, {
          employee_number: self.$store.state.employee_number,
        })
        .then((r) => {
          const res = JSON.parse(r.data.d);
          self.$store.state.myenroll_url = res[0].URL_;
          self.$store.state.url_name = res[0].URL_NAME;
          self.$store.state.service_email = res[0].SERVICE_EMAIL_;
          self.$store.state.service_phone = res[0].SERVICE_PHONE_;
          self.$store.state.autoachText = res[0].ACH_WORD;
          self.$store.state.is_auto_ach_account =
            res[0].AUTOACH == 1 || res[0].AUTOACH == "1" ? true : false;
          self.$store.state.autoachText_word1 = res[0].ACH_WORD_;
          //console.log("", self.$store.state.is_auto_ach_account);
        })
        .catch(function (e) {
          self.loading = false;
          console.log("error -myenroll_url" + e);
        });
    },
    show_ach_instruction() {
      var self = this;
      axios
        .post(
          `${this.methodUrl}/make_payment/Webservice.asmx/show_ach_instruction`,
          {
            employee_number: self.$store.state.employee_number,
          },
        )
        .then((r) => {
          const res = r.data.d;
          self.$store.state.show_ach_instruction_value = res;
        })
        .catch(function (e) {
          self.loading = false;
          console.log("error -show_ach_instruction" + e);
        });
    },

    failedAttempts_redirect() {
      this.errorDialog_2 = false;
      //window.location = this.$store.state.myenroll_url;
      const href = location.href.toLowerCase();
      if (href.indexOf("test") > -1) {
        window.location =
          "https://www.bastest.com/web_projects/MainHomePage/Login.aspx";
      } else {
        window.location = this.$store.state.myenroll_url;
      }
    },
    async onloadCallback(token) {
      var self = this;

      try {
        if (token.length == 0) {
          //reCaptcha not verified
          self.validateRecaptcha = false;
          return false;
        } else {
          self.validateRecaptcha = true;
        }
      } catch (error) {
        console.error("Error verifying reCAPTCHA:", error);
      }
    },
    async onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.validateRecaptcha = false;
    },

    async verifyEELogin() {
      var self = this;
      self.errorDialog_1 = false;
      self.errorDialog_2 = false;
      self.loading = true;
      await axios
        .post(`${this.methodUrl}/make_payment/Webservice.asmx/Verify_EELogin`, {
          rec_locator_: self.recordLocator,
          first_initial: self.firstInitial,
          last_initial: self.lastInitial,
        })
        .then(function (r) {
          var res = JSON.parse(r.data.d);
          self.loading = false;
          // console.log(JSON.stringify(res));
          if (res.length > 0) {
            self.ee_data = res[0];
            self.page_disabled = false;
            // self.mfadialog=true

            if (res[0].ALT_EMAIL) {
              console.log("show privacy dialog");
              self.nextStep = true; //8/18/2026 PRG-1944-show privacy
            } else {
              self.emaildialog = true;
            }
            self.$store.state.employee_number = res[0].EMPLOYEE_NUMBER;
            self.$store.state.account_number = res[0].ACCOUNT_NUMBER;

            setTimeout(() => {
              self.myenroll_url_details();

              // self.show_ach_instruction();
            }, 40);
          } else {
            self.err_counter += 1;
            if (self.err_counter >= 3) {
              self.errorDialog_2 = true;
              self.page_disabled = true;
              self.nextStep = false;
            } else {
              self.errorDialog_1 = true;
              self.nextStep = false;
            }
          }
          self.save_loading = false;
        })
        .catch(function (e) {
          self.loading = false;
          self.save_loading = false;
          console.log("error -Get_selected_coverage_plan" + e);
        });
    },
    //locak the record-lock_ee_record

    lock_ee_record() {
      var self = this;
      self.loading = true;
      axios
        .post(`${this.methodUrl}/make_payment/Webservice.asmx/lock_ee_record`, {
          employeeNumber: self.$store.state.employee_number,
        })
        .then((r) => {
          const res = r.data.d;

          self.$store.state.lock_value = res;
        })
        .catch(function (e) {
          self.loading = false;
          console.log("error -lock_ee_record" + e);
        });
    },

    save_useremail_() {
      var self = this;
      axios
        .post(
          `${this.methodUrl}/make_payment/Webservice.asmx/save_useremail_`,
          {
            employee_number_: self.$store.state.employee_number,
            email_address_: self.emailEntry,
          },
        )
        .then((r) => {
          const res = r.data.d;
          console.log(res);
        })
        .catch(function (e) {
          console.log("error -save_useremail_ : " + e);
        });
    },
    ///Lakshmi- 6/27./2025 validate email
    async Validate_email_exist() {
      var self = this;
      var email_message = "";
      var emailadd_ = self.emailEntry.trim();
      try {
        const url =
          self.methodUrl + "/make_payment/Webservice.asmx/Validate_email_exist";
        const data = { email_: emailadd_ };
        const response = await axios.post(url, data);
        var res = response.data.d;
        if (res == 1 || res == "1") {
          email_message = "Email address already exists. ";
        } else {
          email_message = "";
        }
        return email_message;
      } catch (err) {
        self.saveloading = false;
        console.log(err);
      }
    },

    async saveemail() {
      this.emaildialog = false;
      const emailResult = await this.Validate_email_exist();
      if (emailResult == "") {
        this.email_error_dialog = false;
        await this.save_useremail_();
        this.nextStep = true;
      } else {
        this.email_error_dialog = true;
      }
    },
    reenter() {
      this.emaildialog = true;
      this.email_error_dialog = false;
      this.emailEntry = "";
      this.confirmEmail = "";
    },

    ///Lakshmi - 6/27/2025--endpoint to validate email

    //saveemail() {
    //this.emaildialog = false;
    // this.save_useremail_();
    // this.nextStep = true;
    //},

    skip() {
      this.emaildialog = false;
      this.nextStep = true;
    },

    async onSubmit() {
      if (
        // this.recordLocator.length == 6 &&
        // this.firstInitial.length == 1 &&
        // this.lastInitial.length == 1

        this.recordLocator?.trim()?.length === 6 &&
        this.firstInitial?.trim()?.length === 1 &&
        this.lastInitial?.trim()?.length === 1
      ) {
        this.save_loading = true;
        if (this.showrecaptcha) {
          await this.$refs.recaptcha.execute(); //for localhost purpose no need to caheck recaptcha
        } else {
          this.verifyEELogin();
          this.showvalidationdialog = false;
        }
      } else {
        this.showvalidationdialog = true;
      }
    },

    onCancel() {
      console.log("cancel");
    },
    onContinue() {
      this.showprivacy = true;
      //this.lock_ee_record();
      //this.$store.state.step = 2;
    },

    //8/18/2026 PRG-1944-show privacy
    showprivacydialog() {
      this.showprivacy = true;
    },
    onAccept() {
      this.showprivacy = false;
      this.lock_ee_record();
      this.$store.state.step = 2;
      AddSessionInfo(); //add session details
    },
    onDecline() {
      this.failedAttempts_redirect();
    },
  },
};
</script>

<style>
.black-input .v-input__control {
  border-color: black !important;
  color: black !important;
}

.black-input .v-label {
  color: black !important;
}

.black-input .v-input__control:hover {
  border-color: black !important;
}
.vanilla-bg {
  background: #fbf6f3;
  min-height: 100vh;
}

/* Header */
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 16px;
}
.header-logo {
  height: 52px;
  object-fit: contain;
}
.center-logo {
  height: 60px;
}

/* Card */
.elevated-card {
  border-radius: 12px;
  border: 1px solid #e5e5e5;
  background: #fff;
  overflow: hidden;
}
.title {
  color: #4a4a4a;
  font-weight: 600;
  font-size: 30px !important;
  text-align: center;
}
.subtitle {
  color: #6c757d;
}

/* Submit button */
.submit-btn {
  background: #730e58 !important;
  color: #fff !important;
}

/* "Lookup Your Code" link */
.links-row {
  display: flex;
  justify-content: flex-start;
  margin-top: -8px;
  margin-bottom: 8px;
}
.lookup-link {
  color: #1c7c80;
  text-decoration: underline;
  font-weight: 500;
}

/* Corner logos */
.corner-logo {
  position: fixed;
  bottom: 16px;
  height: 24px;
  width: auto;
  display: none; /* default hidden (mobile-first) */
  z-index: 10;
}
.corner-logo.left {
  left: 16px;
}
.corner-logo.right {
  right: 16px;
}

/* Breakpoints to match original (475px & 640px) */
@media (min-width: 475px) {
  .corner-logo {
    display: block;
  }
  .header-logo {
    height: 32px;
  }
}
@media (min-width: 640px) {
  .header-logo {
    height: 36px;
  }
}

@media (max-width: 600px) {
  .form-row {
    padding-left: 12px !important;
    padding-right: 12px !important;
    gap: 2px;
  }
  .black-input .v-input__control {
    min-width: 110px;
  }
  .initial-input .v-input__control {
    min-width: 48px !important;
    max-width: 64px !important;
  }
}
:deep(.my-card.v-card--variant-outlined) {
  border: 1px solid #e0e0e0 !important;
}
.png-overlay {
  --color-navy-900: #0f1a2e;
  --color-navy-800: #14233d;
  --color-navy-700: #1c2f52;
  --color-navy-600: #334155;
  --color-navy-100: #e8ecf5;
  --color-teal-600: #1c7c80;
  --color-teal-500: #23979c;
  --color-teal-300: #6fc7c2;
  --color-teal-100: #e6f4f5;
  --color-plum-700: #730e58;
  --color-plum-900: #3a1246;
  --color-slate-600: #475569;
  --color-neutral-050: #f8fafc;
  --color-neutral-100: #f1f5f9;
  --color-neutral-200: #e2e8f0;
  --color-neutral-250: #e5e5e5;
  --color-white: #ffffff;

  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 26, 46, 0.6); /* navy-900 wash */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}

.png-card {
  width: 100%;
  max-width: 620px;
  border: 1px solid var(--color-neutral-250);
  border-radius: 14px;
}
.png-card1 {
  border: 1px solid #cbedef !important;
}
.png-logo-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 22px;
}

.png-logo-mark {
  display: flex;
  align-items: center;
  gap: 6px;
}

.png-logo-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 6px 6px 6px 0;
  background: var(--color-plum-700);
  transform: rotate(-8deg);
}

.png-logo-icon--teal {
  background: var(--color-teal-600);
}

.png-logo-text {
  font-weight: 800;
  font-size: 20px;
  letter-spacing: 0.5px;
  color: var(--color-navy-700);
}

.png-logo-text--bas {
  color: var(--color-plum-700);
}

.png-logo-text--ccs {
  color: var(--color-teal-600);
}

.png-logo-divider {
  width: 1px;
  height: 22px;
  background: var(--color-neutral-200, #e2e8f0) !important;
}

.png-title {
  margin: 0 0 16px;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  color: var(--color-navy-700, #1f3a68) !important;
}

.png-body {
  margin: 0 0 28px;
  color: var(--color-slate-600);
  font-size: 15px;
  line-height: 1.6;
  text-align: left;
}

.png-button-row {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.png-btn {
  min-width: 140px;

  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.3px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
}

.png-btn:focus-visible {
  outline: 3px solid var(--color-teal-300);
  outline-offset: 2px;
}

.accept {
  background: var(--color-teal-600) !important;
  color: var(--color-white) !important;
}

.accept:hover {
  background: var(--color-teal-500);
}

.decline {
  background: var(--color-white, #ffffff) !important;
  color: var(--color-navy-700, #1f3a68) !important;
  border-color: var(--color-neutral-200, #e2e8f0) !important;
}

.decline:hover {
  background: var(--color-neutral-100);
  border-color: var(--color-neutral-250);
}
</style>
